<template>
  <div class="loader">
    <v-progress-circular :size="50" :width="3" color="grey" indeterminate>
    </v-progress-circular>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  }
}
</script>
<style lang="scss">
  .loader {
    position: absolute;
    top: calc(50% - 25px);
    left: calc(50% - 25px);
    .progress-circular--indeterminate svg {
      position: relative;
    }
    .progress-circular__info {
      img {
        position: relative;
        top: 3px;
      }
    }
    .logo-color {
      display: block;
    }
  }
</style>
